import { Link } from "react-router-dom";
import { originalCompare } from "@/mocks/anime";

export default function CompareSection() {
  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-medium text-primary-600">ORIGINAL VS ANIME</span>
          <h2 className="font-heading mt-1 text-2xl text-foreground-900 md:text-3xl">原作细节大对比</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-600">
            动画在还原原作主线的基础上做了取舍。对照着看，你会发现很多被藏在细节里的惊喜与彩蛋。
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {originalCompare.map((row, idx) => (
            <div
              key={row.point}
              className={`grid grid-cols-1 gap-3 p-5 sm:grid-cols-3 sm:items-center ${
                idx > 0 ? "border-t border-background-200" : ""
              }`}
            >
              <div className="text-sm font-medium text-foreground-900">{row.point}</div>
              <div className="flex items-start gap-2 text-sm leading-6 text-foreground-600">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-eraser-line text-xs"></i>
                </span>
                <span>{row.original}</span>
              </div>
              <div className="flex items-start gap-2 text-sm leading-6 text-foreground-600">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-movie-2-line text-xs"></i>
                </span>
                <span>{row.anime}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <Link to="/ending" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer">
            查看结局与彩蛋解析
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}